import config from './config';
import { hasAnalyticsConsent } from './consent';

// Conversions suivies pour Google Analytics et Google Ads (uniquement avec l'accord du visiteur).

const sendConversion = (eventName, conversionKey, params = {}) => {
  if (!hasAnalyticsConsent() || typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
  const label = config.adsConversionLabels[conversionKey];
  if (config.adsId && label) {
    window.gtag('event', 'conversion', { send_to: `${config.adsId}/${label}`, value: 1.0, currency: 'EUR' });
  }
};

// Formulaire de contact envoyé avec succès.
export const trackLead = () => sendConversion('generate_lead', 'lead', { method: 'contact_form' });

// Clic sur un numéro de téléphone (lien tel:), où qu'il soit sur le site.
export const trackPhoneClicks = () => {
  const handler = (event) => {
    const link = event.target.closest && event.target.closest('a[href^="tel:"]');
    if (link) sendConversion('phone_call_click', 'call', { link_url: link.getAttribute('href') });
  };
  document.addEventListener('click', handler);
  return () => document.removeEventListener('click', handler);
};
